<template>
  <div>
    <div class="ysbbliebiao">
      <div v-if="!dialogFormVisible">
        <div style="background-color: white; border-radius: 5px">
          <div class="headerSearch">
            <el-form
              :model="bgform"
              style="display: flex"
              class="demo-form-inline"
              label-width="90px"
              label-position="right"
            >
              <el-form-item label="运输证编号:">
                <el-input
                  v-model="bgform.param.yszBh"
                  placeholder="请输入"
                />
              </el-form-item>
              <el-form-item label="化学品:">
                <el-input
                  v-model="bgform.param.hxpMc"
                  placeholder="请输入"
                />
              </el-form-item>
              <el-form-item label="运输日期:">
                <el-col :span="10">
                  <el-date-picker
                    v-model="bgform.param.beginTime"
                    type="date"
                    style="width: 100%"
                    placeholder="开始时间"
                    :picker-options="startTime"
                  />
                </el-col>
                <el-col
                  style="text-align: center"
                  class="line"
                  :span="3"
                >-</el-col>
                <el-col :span="10">
                  <el-date-picker
                    v-model="bgform.param.endTime"
                    type="date"
                    style="width: 100%"
                    placeholder="选择日期"
                    :picker-options="endTime"
                  />
                </el-col>
              </el-form-item>
              <el-form-item label="状态:" label-width="50px">
                <el-select
                  v-model="bgform.param.zt"
                  placeholder="请选择"
                  @change="hztchange"
                >
                  <el-option
                    v-for="item in zhuangtaixiala"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-button
                type="primary"
                class="sousuoButton"
                size="small"
                icon="el-icon-search"
                @click="handleCurrentChange(1)"
              >搜索</el-button>
              <el-button
                class="resetbutton"
                size="small"
                icon="el-icon-refresh-right"
                @click="reset"
              >重置</el-button>
            </el-form>
          </div>
        </div>

        <div class="shckTableContain">
          <div class="tableXS">
            <div class="addmesbgc">
              <el-button
                v-preventReClick
                type="primary"
                icon="el-icon-plus"
                class="addmes"
                size="mini"
                @click="addMes(0)"
              >新增</el-button>
              <el-button
                v-preventReClick
                icon="el-icon-upload"
                size="mini"
                class="addmes"
                @click="exportlb"
              >导出</el-button>
            </div>

            <el-table
              ref="filterTable"
              :data="tableData"
              style="width: 100%"
              border
            >
              <el-table-column
                label="报备编号"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span size="medium">{{ scope.row.bbbh }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="运输证编号"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span size="medium">{{ scope.row.yszBh }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="化学品名称"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span size="medium">{{ scope.row.hxpMc }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="抵达数量"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span size="medium" v-if="!isEmpty(scope.row.qysl)">{{
                    scope.row.ddsl
                  }}</span>
                  <span size="medium" v-if="!isEmpty(scope.row.qyslDwMc)">{{
                      " (" + scope.row.ddslDwMc + ")"
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="发货单位"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span size="medium">{{ scope.row.fhdw }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="承运单位"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span size="medium">{{ scope.row.cydw }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收货单位"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span size="medium">{{ scope.row.shdw }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="运输日期"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span size="medium">{{ scope.row.ysrq }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="bgcs" label="变更次数">
                <template slot-scope="scope">
                  <span
                    v-preventReClick
                    style="cursor: pointer"
                    @click="bgcsClick(scope.row)"
                  >{{ scope.row.bgcs }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="状态"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.zt == '01'"
                    style="color: #6fc89a"
                  >已报备</span>
                  <span
                    v-if="scope.row.zt == '11'"
                    style="color: #43a5e2"
                  >变更审批中</span>
                  <span
                    v-if="scope.row.zt == '00'"
                    style="color: #333333"
                  >草稿</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="200px">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.zt == '01' || scope.row.zt == '11'"
                    v-preventReClick
                    size="mini"
                    icon="el-icon-document"
                    style="
                      background-color: #4170ff;
                      border: none;
                      color: white;
                    "
                    @click="addMes(1, scope.row.id, scope.row)"
                  >查看</el-button>
                  <el-button
                    v-if="scope.row.zt == '01'"
                    v-preventReClick
                    size="mini"
                    icon="el-icon-edit"
                    style="
                      background-color: #feb800;
                      border: none;
                      color: white;
                    "
                    @click="addMes(2, scope.row.id, scope.row)"
                  >变更</el-button>
                  <el-button
                    v-if="scope.row.zt == '11'"
                    v-preventReClick
                    disabled
                    size="mini"
                    icon="el-icon-edit"
                    style="
                      background-color: #c8c9cc;
                      border: none;
                      color: white;
                    "
                    @click="addMes(2, scope.row.id)"
                  >变更</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    size="mini"
                    icon="el-icon-edit"
                    style="
                      background-color: #4170ff;
                      border: none;
                      color: white;
                    "
                    @click="addMes(3, scope.row.id)"
                  >编辑</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    size="mini"
                    icon="el-icon-delete"
                    style="
                      background-color: #ff5721;
                      border: none;
                      color: white;
                    "
                    @click="hshanchu(scope.row.id)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="prev,pager,next,jumper,total,sizes"
              :total="total"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="bgform.size"
              :current-page.sync="currentPage"
              @size-change="pagesizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
    <bgcs
      :bgwindow="bgwindow"
      bgcs-t-k-name="运输报备"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <yunshubbToggle
      v-if="dialogFormVisible"
      ref="yunshubbToggle"
      :djsjshow="djsjshow"
      :ckdisable="ckdisable"
      :bgdisable="bgdisable"
      :children-type="childrenType"
      :shcktype="type"
      :xkz-bh="xkzBh"
      @close-dialog="closeDialog"
    />
  </div>
</template>

<script>
// 获取接口地址
import yunshubbToggle from './yunshubbToggle.vue'
import bgcs from '@/components/bgcs'
import {
  APIBBzhuangtai, // 状态下拉
  APIysbbHqlb, // 获取列表
  APIshanchuysbb, // 删除
  APIysbbdaochu // 导出
} from '@/assets/js/wangshuai.js'
import {isEmpty} from "@/utils/tool";
import {dealDataGy} from "@/utils/ppp";

export default {
  name: 'Yunshubb',
  components: { yunshubbToggle, bgcs },
  data() {
    return {
      zhuangtaixiala: [], // 状态下拉
      startTime: {
        disabledDate: (time) => {
          if (this.bgform.param.endTime) {
            return (
              time.getTime() > new Date(this.bgform.param.endTime).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.bgform.param.beginTime) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.bgform.param.beginTime).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      // 搜素表格
      bgform: {
        page: 1,
        size: 10,
        param: {
          hxpMc: '',
          yszBh: '',
          beginTime: '',
          endTime: '',
          zt: ''
        }
      },
      // 登记时间
      djsjshow: false,
      // 查看禁止选择
      ckdisable: false,
      // 变更
      bgdisable: false,
      formInline: {
        name: '',
        ckmc: '',
        sqKs: '',
        sqJs: '',
        status: ''
      },
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0,
      dialogFormVisible: false, // 对话框的显示隐藏
      type: false, // 添加和编辑，可编辑，查看不可编辑
      tableData: [],
      xkzBh: '',
      bgwindow: false
    }
  },

  created: function() {
    if (this.$route.params.zjlx) {
      this.$nextTick(() => {
        this.addMes(3)
      })
    }
    if (this.$route.params.xkzBh) {
      this.$nextTick(() => {
        this.xkzBh = this.$route.params.xkzBh
        this.addMes(0)
      })
    }

    // this.getcyryMess({
    //   page: this.currentPage,
    //   size: this.pagesize,
    // });
  },
  mounted() {
    this.htableDataList()
    // 搜索下拉状态
    APIBBzhuangtai().then((res) => {
      this.zhuangtaixiala = res.data.data
    })
  },
  methods: {
    isEmpty,
    // 点击变更次数
    bgcsClick(curRow) {
      this.curRowObj = curRow
      this.$bus.emit('bgcsOpen', curRow, 'ysbb')
      this.bgwindow =
        curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    }, // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    hztchange(data) {
      console.log(data)
    },
    // 删除
    hshanchu(id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        APIshanchuysbb(id).then((res) => {
          this.htableDataList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
      })
    },

    // 获取表格数据
    async htableDataList() {
      this.bgform.param.vdata = await dealDataGy()
      APIysbbHqlb(this.bgform).then((res) => {
        this.tableData = res.data.data.rows
        this.total = res.data.data.total
      })
    },

    // 点击添加按钮
    addMes(type, id, row) {
      this.dialogFormVisible = true
      this.type = false
      if (type == 0) {
        // 新增
        this.djsjshow = false
        this.ckdisable = false
        this.bgdisable = false
        this.childrenType = '新增'
      } else if (type == 1) {
        // 查看
        this.djsjshow = true
        this.ckdisable = true
        this.bgdisable = false
        this.childrenType = '查看'
        setTimeout(() => {
          this.$bus.emit('fatherToChil', row, 'ysbb')
          this.$refs.yunshubbToggle.hhuoquxiangqing(id)
        }, 30)
      } else if (type == 2) {
        // 变更
        this.djsjshow = true
        this.ckdisable = false
        this.bgdisable = true
        this.childrenType = '变更'
        setTimeout(() => {
          this.$bus.emit('fatherToChil', row, 'ysbb')
          this.$refs.yunshubbToggle.hhuoquxiangqing(id)
        }, 30)
      } else if (type == 3) {
        // 编辑
        this.djsjshow = true
        this.ckdisable = false
        this.bgdisable = false
        this.childrenType = '编辑'
        setTimeout(() => {
          this.$refs.yunshubbToggle.hhuoquxiangqing(id)
        }, 30)
      }
      //   this.$refs.dialogcyry.getformMes({});
    },
    // 点击重置时
    reset() {
      this.bgform.page = 1
      this.bgform.size = 10
      this.bgform.param.hxpMc = ''
      this.bgform.param.yszBh = ''
      this.bgform.param.beginTime = ''
      this.bgform.param.endTime = ''
      this.bgform.param.zt = ''

      this.htableDataList()
      // 调用查询接口
    },
    // 导出
    exportlb() {
      APIysbbdaochu(this.bgform).then((res) => {
        const table = '报备运输'
        const a = document.createElement('a')
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 编辑
    // handleEdit(index, row) {
    //   console.log(index, row);
    //   this.dialogFormVisible = true;
    //   this.type = false;
    //   this.$refs.dialogcyry.getformMes(row);
    // },
    // 查看
    // handleSelect(index, row) {
    //   console.log(index, row);
    //   this.dialogFormVisible = true;
    //   this.type = true;
    // },
    // 关闭对话框
    closeDialog() {
      this.dialogFormVisible = false
    },
    // 当前页码改变时
    // 内部分页方法
    pagesizeChange(val) {
      this.bgform.size = val
      this.htableDataList()
    },
    handleCurrentChange(val) {
      this.bgform.page = val
      this.htableDataList()
    }
  }
}
</script>

<style lang="less" scoped>
.sousuoButton {
  width: 90px;
  height: 39px;
  background: hsl(225, 100%, 63%);
  border-radius: 20px;
  border-color: #4170ff;
}
.resetbutton {
  width: 90px;
  height: 39px;
  border-radius: 20px;
}
.el-button--primary {
  color: #fff;
  background-color: #4170ff;
  border-color: #4170ff;
}
/deep/ .el-pagination__total {
  margin-left: 8px;
}
.el-pagination {
  padding: 10px 0;
  border: 1px solid #ebeef5;
  border-top: 0;
}
.ysbbliebiao {
  width: 95%;
  margin: 0 auto;

  // background-color: white;
  max-width: 1518px;
  .headerSearch {
    margin: 0 auto;
    padding: 30px 0 20px 0;
    display: flex;
    align-items: center;
    margin-top: 30px;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form {
      width: 90%;
      margin: auto;
    }
    /deep/ .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
    }
  }
  .shckTableContain {
    margin-left: auto;
    margin-right: auto;
    margin-top: 11px;
    background-color: white;
    padding-bottom: 57px;
    padding-top: 40px;
    .tableXS {
      width: 90%;
      margin: 0 auto;
      /deep/ .el-table {
        z-index: 0;
      }
      /deep/ .el-table .has-gutter tr th {
        background: #f4f4f4;
      }
      .addmesbgc {
        background: #f4f4f4;
        padding: 12px 10px;
        border-bottom: 1px solid #ebeef5;
        .addmes:nth-child(1) {
          // margin: 15px;
          border: none;
        }
      }
    }
  }
}

.el-form-item__label {
  height: 41px;
}
.el-form--inline .el-form-item {
  margin-right: 50px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
